import { useQuery } from "@tanstack/react-query";
import { tagGet } from "common/api/asocijator/asocijator_tag";
import { QUERY_KEYS } from "constant/react_query";

export const useTagGet = (id: string) => {
  const { data: tag } = useQuery(
    [QUERY_KEYS.ASOCIJATOR_TAG_GET, id],
    async () => {
      const result = await tagGet(id);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof tag !== "undefined" && tag !== "" ? tag : null;
  return result;
};
